import { Link } from "react-router-dom";
import { bookingStatusLabel } from "@/lib/bookingStatus";
import { formatGermanDate } from "@/lib/dates";
import { formatCurrency } from "@/lib/money";
import type { BookingSummary } from "@/lib/guestPortalTypes";
import { periodLabelBadgeClass, periodLabelText } from "@/lib/guestPortalLabels";
import { PaymentSummary } from "@/components/guest-portal/PaymentSummary";

export function BookingStayCard({ item }: { item: BookingSummary }) {
  const { booking, period_label, payment } = item;
  const nights =
    booking.nights > 0
      ? booking.nights
      : Math.max(
          1,
          Math.round(
            (new Date(booking.departure_date).getTime() -
              new Date(booking.arrival_date).getTime()) /
              86400000,
          ),
        );

  return (
    <li className="overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm transition hover:border-brand-200 hover:shadow-md">
      <Link to={`/portal/aufenthalt/${booking.id}`} className="block p-4 sm:p-5">
        <div className="flex flex-wrap items-start justify-between gap-2">
          <div>
            <p className="font-semibold text-brand-800">
              {booking.status === "requested" ? bookingStatusLabel(booking.status) : booking.booking_number}
            </p>
            <p className="mt-1 text-sm text-slate-600">
              {formatGermanDate(booking.arrival_date)} – {formatGermanDate(booking.departure_date)}
            </p>
          </div>
          <div className="flex flex-wrap justify-end gap-1.5">
            <span
              className={`rounded-full px-2.5 py-0.5 text-xs font-medium capitalize ${periodLabelBadgeClass(period_label)}`}
            >
              {periodLabelText(period_label)}
            </span>
            <span className="rounded-full bg-slate-100 px-2.5 py-0.5 text-xs text-slate-700">
              {bookingStatusLabel(booking.status)}
            </span>
          </div>
        </div>

        <p className="mt-3 text-sm text-slate-600">
          {nights} {nights === 1 ? "Nacht" : "Nächte"} · {booking.adults} Erw.
          {booking.children > 0 ? `, ${booking.children} Kind(er)` : ""}
          {booking.dogs > 0 ? `, ${booking.dogs} Hund(e)` : ""}
        </p>

        <p className="mt-2 text-sm font-medium text-slate-800">
          {booking.price_pending
            ? "Preis folgt"
            : `${formatCurrency(booking.total_amount, booking.currency)} inkl. MwSt.`}
        </p>

        <PaymentSummary
          payment={payment}
          totalAmount={booking.total_amount}
          currency={booking.currency}
          compact
        />

        <p className="mt-3 text-xs font-medium text-brand-700">Details anzeigen →</p>
      </Link>
    </li>
  );
}
